import type { ReactNode } from 'react';
import { Size2MixAppShell, type Size2MixAppShellProps } from './Size2MixAppShell';
import { Size2MixNetworkIcon } from './Size2MixNetworkIcon';
import { Size2MixSecondaryNav, Size2MixSecondaryNavTitle } from './Size2MixSecondaryNav';
import type { Size2MixNetworkSummary, Size2MixSecondaryNavItem, NetworkPageId } from './types';

export const NETWORK_PAGES: Size2MixSecondaryNavItem<NetworkPageId>[] = [
    { id: 'general', icon: 'remove_red_eye', label: 'Général' },
    { id: 'import-export', icon: 'swap_horiz', label: 'Import/export' },
    { id: 'topology', icon: 'map', label: 'Topologie' },
    { id: 'production', icon: 'factory', label: 'Production' },
    { id: 'plannings', icon: 'insert_invitation', label: 'Plannings' },
    { id: 'optimisations', icon: 'stacked_bar_chart', label: 'Optimisations' },
];

export interface NetworkShellProps extends Omit<Size2MixAppShellProps, 'secondaryNav' | 'activePrimary'> {
    network: Pick<Size2MixNetworkSummary, 'name' | 'fluidType'>;
    activePage: NetworkPageId;
    onNavigate?: (page: NetworkPageId) => void;
    children: ReactNode;
}

/**
 * Pattern 4b — app shell + network secondary navigation (Général … Optimisations).
 * Content is full-bleed by default (`contentPadding = 0`) because tabbed pages start with `Size2MixTabs` at the very top;
 * pages without tabs add their own padding (Nemo uses `p-5` = 20px).
 */
export function NetworkShell({ network, activePage, onNavigate, children, contentPadding = 0, ...shellProps }: NetworkShellProps) {
    return (
        <Size2MixAppShell
            activePrimary="contracts"
            contentPadding={contentPadding}
            {...shellProps}
            secondaryNav={
                <Size2MixSecondaryNav
                    header={<Size2MixSecondaryNavTitle icon={<Size2MixNetworkIcon fluidType={network.fluidType} />} title={network.name} />}
                    items={NETWORK_PAGES}
                    activeId={activePage}
                    onSelect={onNavigate}
                />
            }
        >
            {children}
        </Size2MixAppShell>
    );
}
